module.exports = __webpack_public_path__ + "static/media/AppIconRound.b12acbb0.png";